import type { useCart } from '@order/hooks';
import { useTippingEnabledForCurrentOrderType } from '@order/hooks';

import type { CheckoutPayload } from '../../Checkout.utils';
import { applyCredit, withTip } from '../../Checkout.utils';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Reusable hook that returns the current order ledger along with additional tip and credit info.
 */
export const useCheckoutLedger = (params: UseCheckoutLedgerParams) => {
  const { cart, payload, credit } = params;

  const isTippingEnabled = useTippingEnabledForCurrentOrderType();
  const shouldApplyPickupTip = cart?.orderType === 'PICKUP' && isTippingEnabled;

  const withAppliedTip = withTip({ cart, payload, shouldApplyPickupTip });

  return { ledger: applyCredit(withAppliedTip, credit) };
};

// ─── UseCheckoutLedgerParams ─────────────────────────────────────────────────

type UseCheckoutLedgerParams = Readonly<{
  cart: ReturnType<typeof useCart>['cart'];
  payload: CheckoutPayload;
  credit: number;
}>;
